/* CorePeptides — theme.js
   Real Shopify cart integration. No fake routing, no homepage redirects.
*/
(function () {
  'use strict';
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const on = (el, ev, fn) => el && el.addEventListener(ev, fn);
  const money = (cents) => 'AED ' + (cents / 100).toFixed(2);

  /* ════════════════════════════════
     MOBILE MENU
  ════════════════════════════════ */
  const mBtn = $('#mobile-menu-btn'), mNav = $('#mobile-nav');
  on(mBtn, 'click', () => {
    const open = mNav.classList.toggle('open');
    mBtn.setAttribute('aria-expanded', String(open));
    mNav.setAttribute('aria-hidden', String(!open));
  });

  /* ════════════════════════════════
     CART BADGE — always reflects real Shopify cart
  ════════════════════════════════ */
  const badge = $('#cart-count');
  function setBadge(n) { if (badge) badge.textContent = n; }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
    return r.json();
  }

  fetchCart().then(cart => setBadge(cart.item_count)).catch(() => {});

  /* ════════════════════════════════
     CART DRAWER
  ════════════════════════════════ */
  const overlay = $('#cart-overlay');
  const drawer  = $('#cart-drawer');
  const cdBody  = $('#cd-body');
  const cdSub   = $('#cd-subtotal');

  function openDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.add('open');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    renderDrawer();
  }
  function closeDrawer() {
    if (!overlay || !drawer) return;
    overlay.classList.remove('open');
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  on($('#cart-open'), 'click', (e) => { e.preventDefault(); openDrawer(); });
  on($('#cart-close'), 'click', closeDrawer);
  on(overlay, 'click', closeDrawer);
  on(document, 'keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  async function renderDrawer() {
    if (!cdBody) return;
    let cart;
    try { cart = await fetchCart(); }
    catch {
      cdBody.innerHTML = '<div class="cd-empty"><p>Unable to load cart. Please refresh.</p></div>';
      return;
    }
    setBadge(cart.item_count);
    if (cdSub) cdSub.textContent = money(cart.total_price);

    if (cart.item_count === 0) {
      cdBody.innerHTML = `<div class="cd-empty"><p>Your cart is empty.</p>
        <a href="/collections/all" style="color:#fff;font-size:.72rem;font-weight:700;letter-spacing:.14em;text-transform:uppercase;margin-top:12px;text-decoration:underline;display:inline-block">Continue Shopping</a></div>`;
      return;
    }

    cdBody.innerHTML = cart.items.map(item => `
      <div class="cd-item">
        <div class="cd-item-img">
          <img src="${window.__PEN_ASSET_URL__ || (item.image ? item.image.replace(/http:/g, 'https:') : '')}" alt="${item.product_title}" width="68" height="68" loading="lazy">
        </div>
        <div class="cd-item-info">
          <p class="cd-item-name">${item.product_title}${item.variant_title && item.variant_title !== 'Default Title' ? ` — ${item.variant_title}` : ''}</p>
          <p class="cd-item-price">${money(item.final_price)}</p>
          <div class="cd-item-qty">
            <button data-line="${item.key}" data-q="${item.quantity - 1}">−</button>
            <span class="qty-n">${item.quantity}</span>
            <button data-line="${item.key}" data-q="${item.quantity + 1}">+</button>
            <span class="cd-rm" data-line="${item.key}" data-q="0">Remove</span>
          </div>
        </div>
      </div>`).join('');

    cdBody.querySelectorAll('[data-line]').forEach(el => {
      on(el, 'click', async () => {
        await changeCartLine(el.dataset.line, parseInt(el.dataset.q, 10));
        renderDrawer();
      });
    });
  }

  async function changeCartLine(lineKey, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: qty })
      });
    } catch (err) {
      console.error('Cart change failed', err);
    }
  }

  /* ════════════════════════════════
     VIALS PAGE — CATEGORY FILTER

     Filters the already-rendered vial cards in place. No fetch, no
     reload: every card is on the page, each tagged with the categories
     it belongs to, so switching is instant.

     The chosen category is written to ?cat= via replaceState, so coming
     back from a product page (or sharing the link) keeps the category.
  ════════════════════════════════ */
  function initVialCategories() {
    const tabs = $('#vials-tabs');
    const grid = $('#vials-grid');
    if (!tabs || !grid) return;

    const countEl = $('#vials-count');
    const labelEl = $('#vials-result-label');
    const cards   = $$('.vial-card', grid);

    function apply(slug, pushUrl) {
      let shown = 0;
      cards.forEach(card => {
        const cats = (card.dataset.vialCats || '').split(/\s+/);
        const show = cats.indexOf(slug) !== -1;
        card.hidden = !show;
        card.style.display = show ? '' : 'none';
        if (show) shown++;
      });

      let label = 'ALL VIALS';
      $$('.pp-tab', tabs).forEach(t => {
        const on = t.dataset.vialCat === slug;
        t.classList.toggle('pp-tab--active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) label = t.textContent.trim();
      });

      // textContent, not innerHTML — the label is plain text and rebuilding
      // the markup each time would stale out any cached child reference.
      if (labelEl) {
        labelEl.textContent = label + ' — ' + shown + (shown === 1 ? ' PRODUCT' : ' PRODUCTS');
      } else if (countEl) {
        countEl.textContent = shown;
      }

      if (pushUrl) {
        try {
          const u = new URL(window.location.href);
          if (slug === 'all') u.searchParams.delete('cat');
          else u.searchParams.set('cat', slug);
          history.replaceState(null, '', u);
        } catch (e) { /* non-fatal */ }
      }
    }

    $$('.pp-tab', tabs).forEach(tab => {
      on(tab, 'click', () => apply(tab.dataset.vialCat, true));
    });

    // Restore ?cat= on load; default to All Vials.
    let start = 'all';
    try {
      const q = new URLSearchParams(window.location.search).get('cat');
      if (q && $$('.pp-tab', tabs).some(t => t.dataset.vialCat === q)) start = q;
    } catch (e) { /* default stands */ }
    apply(start, false);
  }
  initVialCategories();

  /* ════════════════════════════════
     PRODUCT PAGE — FORMAT DROPDOWN VARIANT SELECTOR
  ════════════════════════════════ */
  function initVariantSelector() {
    const trigger   = $('#fmt-trigger');
    const list      = $('#fmt-list');
    const trigText  = $('#fmt-trigger-text');
    const trigPrice = $('#fmt-trigger-price');
    if (!trigger || !list) return;

    const select     = $('#pdp-variant-select');
    const priceEl    = $('#pdp-price');
    const formatEl   = $('#pdp-detail-format');
    const subtitleEl = $('#pdp-sub-text');
    const featFmt    = $('#feat-format');
    const atcBtn     = $('#pdp-atc-btn');
    const atcLabel   = $('#pdp-atc-label');
    const buyNowBtn  = $('#pdp-buy-now');

    // Gallery slide 0 image for variant image swapping
    const slide0Img = document.querySelector('#pgal-track .pgal-slide[data-index="0"] .pgal-img');

    let isOpen = false;

    function openDropdown() {
      isOpen = true;
      list.style.display = 'block';
      list.style.height = '0';
      list.style.overflow = 'hidden';
      list.removeAttribute('aria-hidden');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('fmt-trigger--open');
      const h = list.scrollHeight;
      list.style.transition = 'height 0.28s cubic-bezier(.22,.68,0,1)';
      requestAnimationFrame(() => { list.style.height = h + 'px'; });
    }

    function closeDropdown() {
      isOpen = false;
      list.style.transition = 'height 0.22s cubic-bezier(.22,.68,0,1)';
      list.style.height = '0';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('fmt-trigger--open');
      list.setAttribute('aria-hidden', 'true');
      setTimeout(() => {
        if (!isOpen) { list.style.display = 'none'; list.style.height = ''; }
      }, 240);
    }

    on(trigger, 'click', () => isOpen ? closeDropdown() : openDropdown());

    // Close on outside click
    on(document, 'click', e => {
      if (isOpen && !e.target.closest('#fmt-drop')) closeDropdown();
    });

    // Close on Escape
    on(document, 'keydown', e => {
      if (e.key === 'Escape' && isOpen) closeDropdown();
    });

    // Applies a format option to the whole page. `animate` is false when this
    // runs on page load (restoring ?variant= from the URL), so the gallery and
    // price swap in instantly instead of fading from the wrong variant.
    //
    // Deliberately NOT guarded by data-sold-out: a sold-out variant must still
    // be selectable from a URL, otherwise arriving at an out-of-stock vial
    // link would silently leave the pen selected. The click handler keeps the
    // guard; this function does not.
    function applyOption(opt, animate, pushUrl) {
        // Mark active
        $$('.fmt-option').forEach(o => {
          o.classList.remove('fmt-option--active');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('fmt-option--active');
        opt.setAttribute('aria-selected', 'true');

        // Read data
        const vid       = opt.dataset.variantId;
        const price     = opt.dataset.variantPrice;
        const title     = opt.dataset.variantTitle;
        const available = opt.dataset.variantAvailable === 'true';
        const img       = opt.dataset.variantImage;
        const isVial    = opt.dataset.variantIsVial === 'true';
        const fmtLabel  = opt.dataset.variantFormat;
        const invQty    = parseInt(opt.dataset.variantInventory, 10);
        const invTracked= opt.dataset.variantTracked === 'shopify';
        const sku       = opt.dataset.variantSku || '';
        const comparePrice = opt.dataset.variantCompare || '';

        // Update trigger display
        if (trigText)  trigText.textContent  = title;
        if (trigPrice) trigPrice.textContent = price + ' AED';

        // Close dropdown
        closeDropdown();

        // Update Shopify form hidden select — this is what Add to Cart posts.
        if (select) select.value = vid;

        // Keep the address bar on the variant being viewed, so a refresh,
        // a copied link or a share all reopen this exact format.
        // replaceState, not pushState: changing format shouldn't fill the
        // back button with one entry per click.
        if (pushUrl !== false) {
          try {
            const u = new URL(window.location.href);
            u.searchParams.set('variant', vid);
            history.replaceState(null, '', u);
          } catch (e) { /* non-fatal */ }
        }

        // The variant image lives on slide 0 — bring the carousel back to it
        // so the shopper actually sees the format they just chose, and mark
        // the matching thumbnail/dot active.
        if (typeof window.__pgalGoTo__ === 'function') window.__pgalGoTo__(0);

        // Swap gallery image with fade
        if (slide0Img && img) {
          const swapImg = () => {
            slide0Img.src = img;
            slide0Img.classList.toggle('pgal-img--vial', isVial);
            slide0Img.classList.toggle('pgal-img--pen',  !isVial);
            slide0Img.style.opacity = '1';
          };
          if (animate) {
            slide0Img.style.transition = 'opacity 0.2s ease';
            slide0Img.style.opacity = '0';
            setTimeout(swapImg, 180);
          } else {
            slide0Img.style.transition = 'none';
            swapImg();
          }
        }

        // Update subtitle
        if (subtitleEl) {
          if (isVial) subtitleEl.textContent = 'RESEARCH PEPTIDE VIAL';
          else if (fmtLabel === 'Nasal Spray') subtitleEl.textContent = 'RESEARCH PEPTIDE NASAL SPRAY';
          else if (fmtLabel === 'Refill Cartridge') subtitleEl.textContent = 'RESEARCH PEPTIDE REFILL';
          else subtitleEl.textContent = 'RESEARCH PEPTIDE PEN';
        }

        // Update format feature bullet
        if (featFmt) {
          const tn = Array.from(featFmt.childNodes).find(n => n.nodeType === 3 && n.textContent.trim());
          if (tn) tn.textContent = fmtLabel;
        }

        // Price fade
        if (priceEl) {
          if (animate) {
            priceEl.style.transition = 'opacity 0.16s ease';
            priceEl.style.opacity = '0';
            setTimeout(() => { priceEl.textContent = price; priceEl.style.opacity = '1'; }, 140);
          } else {
            priceEl.style.transition = 'none';
            priceEl.textContent = price;
            priceEl.style.opacity = '1';
          }
        }

        // Format detail row
        if (formatEl) formatEl.textContent = isVial ? title : title + ' per pen';

        // Availability
        if (atcBtn)     atcBtn.disabled     = !available;
        if (atcLabel)   atcLabel.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        if (buyNowBtn)  buyNowBtn.disabled   = !available;

        // Low-stock indicator — instant, driven by real inventory_quantity
        const stockMsg = document.getElementById('pdp-stock-msg');
        if (stockMsg) {
          const showLow = invTracked && !isNaN(invQty) && invQty > 0 && invQty < 10;
          stockMsg.classList.toggle('pdp-stock-msg--visible', showLow);
        }

        // PT-141-only nasal-spray note (element only exists on that product)
        const pt141Note = document.getElementById('pdp-pt141-note');
        if (pt141Note) {
          pt141Note.classList.toggle('pdp-pt141-note--visible', title.indexOf('Nasal Spray') !== -1);
        }

        // Compare-at price
        const compareEl = document.getElementById('pdp-price-compare');
        if (compareEl) {
          if (comparePrice) { compareEl.textContent = comparePrice + ' AED'; compareEl.style.display = ''; }
          else { compareEl.textContent = ''; compareEl.style.display = 'none'; }
        }

        // SKU
        const skuRow = document.getElementById('pdp-detail-sku-row');
        const skuCell = document.getElementById('pdp-detail-sku');
        if (skuRow && skuCell) {
          if (sku) { skuCell.textContent = sku; skuRow.style.display = ''; }
          else { skuCell.textContent = ''; skuRow.style.display = 'none'; }
        }

        // Dose chart — generic strength/format sync for every product with
        // a tabbed chart (not just Retatrutide). Looks up the chart's own
        // formatMatch map (e.g. {'10mg':0,'30mg':1,'60mg':2'}) against the
        // newly selected variant's title text, so adding a new tab to any
        // product's chart never requires touching this code again.
        const doseBtn = document.querySelector('.pdp-dose-btn');
        if (doseBtn) {
          const titleLower = title.toLowerCase().replace(/\s+/g, '');
          const usesClicks = !(isVial || titleLower.indexOf('nasal') !== -1 || titleLower.indexOf('spray') !== -1);
          doseBtn.style.display = usesClicks ? '' : 'none';

          const chartData = (window.__DOSE_CHARTS__ || {})[doseBtn.dataset.chart];
          let matchedTab = null;
          if (chartData && chartData.formatMatch) {
            Object.keys(chartData.formatMatch).forEach(function (key) {
              if (titleLower.indexOf(key) !== -1) matchedTab = chartData.formatMatch[key];
            });
          }
          if (matchedTab !== null) { doseBtn.dataset.chartTab = String(matchedTab); }
          else { delete doseBtn.dataset.chartTab; }

          // If the chart modal is already open on this product, update the
          // visible table immediately rather than waiting for the next open.
          const openModal = document.getElementById('dose-chart-modal');
          if (usesClicks && openModal && openModal.classList.contains('open') && typeof window.__openDoseChart__ === 'function') {
            window.__openDoseChart__(doseBtn.dataset.chart, matchedTab !== null ? matchedTab : undefined, doseBtn.dataset.pdfUrl || undefined);
          } else if (!usesClicks && openModal && openModal.classList.contains('open') && typeof window.__closeDoseChart__ === 'function') {
            window.__closeDoseChart__();
          }
        }
    }

    // Click still refuses sold-out options — a shopper shouldn't be able to
    // pick one from the dropdown.
    $$('.fmt-option').forEach(opt => {
      on(opt, 'click', () => {
        if (opt.dataset.soldOut) return;
        applyOption(opt, true);
      });
    });

    /* ──────────────────────────────────────────────────────────────
       Restore the variant named in the URL (?variant=…).

       Liquid already resolves ?variant= server-side for the price, the
       hidden <select name="id"> and Add to Cart, but the format dropdown
       and the gallery are rendered from the product's first non-refill
       variant, so arriving at a vial link used to show the vial's price
       with the PEN still named in the selector and the pen photo in the
       gallery. This re-applies the URL's variant on load so every
       connected element agrees.

       Only runs when ?variant= is present, so customers arriving from
       Products, Pens, Refills or Bundles keep the normal default.
    ────────────────────────────────────────────────────────────────── */
    function restoreVariantFromURL() {
      let wanted = null;
      try {
        wanted = new URLSearchParams(window.location.search).get('variant');
      } catch (e) { return; }
      if (!wanted) return;

      const opt = Array.from($$('.fmt-option'))
        .find(o => o.dataset.variantId === wanted);
      if (!opt) return;                        // e.g. a refill variant, not listed
      if (opt.classList.contains('fmt-option--active')) return;  // already correct

      applyOption(opt, false);
    }
    restoreVariantFromURL();

    // Back/forward between variant URLs should re-sync too.
    on(window, 'popstate', restoreVariantFromURL);
  }
  initVariantSelector();

  /* ════════════════════════════════
     PRODUCT IMAGE ZOOM
     Click/tap-to-open lightbox. Deliberately not hover-based,
     since hover zoom doesn't exist on touch devices — this pattern
     works identically on desktop, mobile, and iPad.
  ════════════════════════════════ */
  function initImageZoom() { /* replaced by initGallery below */ }
  initImageZoom();

  /* ════════════════════════════════
     PRODUCT IMAGE GALLERY
     Horizontal slider with:
     - Arrow buttons (desktop)
     - Touch swipe (mobile/iPad)
     - Dot navigation
     - Fullscreen lightbox on click
     - Zoom hint visible on slide 0 only
  ════════════════════════════════ */
  (function initGallery() {
    const track    = $('#pgal-track');
    const slides   = track ? $$('.pgal-slide', track) : [];
    const dots     = $$('.pgal-dot');
    const prevBtn  = $('#pgal-prev');
    const nextBtn  = $('#pgal-next');
    const zoomHint = $('#pgal-zoom-hint');
    const lb       = $('#pgal-lightbox');
    const lbImg    = $('#pgal-lb-img');
    const lbClose  = $('#pgal-lb-close');

    if (!track || slides.length === 0) return;

    let current = 0;
    const total = slides.length;

    // Exposed so the variant selector can return the carousel to slide 0
    // (the variant image) whenever the format changes. Assigned below.
    function goTo(idx, animate = true) {
      // Clamp
      idx = Math.max(0, Math.min(total - 1, idx));
      if (idx === current && animate) return;

      // Fade out current, fade in next
      slides[current].classList.remove('pgal-slide--active');
      slides[idx].classList.add('pgal-slide--active');

      // Update dots
      dots.forEach((d, i) => d.classList.toggle('pgal-dot--active', i === idx));

      // Show/hide zoom hint (only on slide 0)
      if (zoomHint) zoomHint.style.opacity = idx === 0 ? '1' : '0';

      // Show/hide arrows at edges
      if (prevBtn) prevBtn.style.opacity = idx === 0 ? '0.3' : '1';
      if (nextBtn) nextBtn.style.opacity = idx === total - 1 ? '0.3' : '1';

      current = idx;
    }

    window.__pgalGoTo__ = goTo;

    // Arrow clicks
    on(prevBtn, 'click', () => goTo(current - 1));
    on(nextBtn, 'click', () => goTo(current + 1));

    // Dot clicks
    dots.forEach(dot => on(dot, 'click', () => goTo(parseInt(dot.dataset.goto, 10))));

    // Touch/swipe
    let touchStartX = 0, touchStartY = 0, dragging = false;
    on(track, 'touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      dragging = true;
    }, { passive: true });
    on(track, 'touchend', e => {
      if (!dragging) return;
      dragging = false;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });

    // Keyboard navigation
    on(document, 'keydown', e => {
      if (lb && lb.classList.contains('open')) return; // lightbox active
      if (e.key === 'ArrowLeft')  goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Lightbox — clicking any slide image opens it fullscreen
    slides.forEach(slide => {
      const img = slide.querySelector('.pgal-img');
      if (!img || !lb || !lbImg) return;
      on(img, 'click', () => {
        lbImg.src = img.src;
        lbImg.alt = img.alt;
        lb.classList.add('open');
        lb.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeLb() {
      if (!lb) return;
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    on(lbClose, 'click', closeLb);
    on(lb, 'click', e => { if (e.target === lb) closeLb(); });
    on(document, 'keydown', e => { if (e.key === 'Escape' && lb && lb.classList.contains('open')) closeLb(); });

    // Init state
    goTo(0, false);
  })();

  /* ════════════════════════════════
     THEME TOGGLE — dark / light
  ════════════════════════════════ */
  (function themeToggle() {
    const KEY = 'cp_theme';
    const btn = $('#theme-toggle');
    if (!btn) return;

    function applyTheme(mode) {
      if (mode === 'light') {
        document.documentElement.classList.add('light-mode');
        btn.setAttribute('aria-label', 'Switch to dark mode');
      } else {
        document.documentElement.classList.remove('light-mode');
        btn.setAttribute('aria-label', 'Switch to light mode');
      }
    }

    // Sync button label with what the pre-paint script already applied
    const saved = (() => { try { return localStorage.getItem(KEY); } catch(e) { return null; } })();
    applyTheme(saved === 'light' ? 'light' : 'dark');

    on(btn, 'click', () => {
      const isLight = document.documentElement.classList.toggle('light-mode');
      const next = isLight ? 'light' : 'dark';
      try { localStorage.setItem(KEY, next); } catch(e) {}
      applyTheme(next);
    });
  })();

  /* ════════════════════════════════
     DOSE CHART MODAL — HTML table, theme-aware
  ════════════════════════════════ */
  (function doseChart() {
    /* ── Dose Chart Data ── */
    var CHARTS = {
      reta: {
        title: 'Retatrutide Click-to-Dose Chart',
        defaultTab: 1,
        formatMatch: { '10mg': 0, '30mg': 1, '60mg': 2 },
        tabs: [
          {
            // 10mg pen — CONCENTRATION CONVERSION, supplied by the owner
            // 26 Oct 2026 and replacing the previous table.
            //
            // Specification: 10 mg total in 2 mL = 5 mg/mL.
            // 1 click = 0.01 mL, therefore 1 click = 0.05 mg.
            //
            // NOTE: the previous table read 5 clicks = 0.5 mg, i.e. 0.1 mg per
            // click — double the concentration this specification gives. The
            // two cannot both be right; these values are the current ones.
            label: 'Retatrutide 10mg',
            tabTitle: 'Retatrutide 10mg — Concentration Conversion Chart',
            cols: ['Clicks', 'Dose'],
            rows: [['10 clicks','0.5 mg'],['20 clicks','1.0 mg'],['30 clicks','1.5 mg'],
                   ['40 clicks','2.0 mg'],['50 clicks','2.5 mg'],['60 clicks','3.0 mg']],
            note: '10 mg total in 2 mL · 5 mg/mL · 1 click = 0.01 mL = 0.05 mg. This is a concentration conversion reference, not a recommended dosing protocol. Click volume must be verified against the pen manufacturer’s specifications.'
          },
          {
            label: 'Retatrutide 30mg',
            cols: ['Clicks', 'Dose'],
            rows: [['8 clicks','1 mg'],['16 clicks','2 mg'],['24 clicks','3 mg'],
                   ['32 clicks','4 mg'],['40 clicks','5 mg'],['48 clicks','6 mg'],
                   ['56 clicks','7 mg'],['60 clicks','7.5 mg']]
          },
          {
            label: 'Retatrutide 60mg',
            cols: ['Clicks', 'Dose'],
            rows: [['8 clicks','2 mg'],['12 clicks','3 mg'],['16 clicks','4 mg'],
                   ['20 clicks','5 mg'],['24 clicks','6 mg'],['28 clicks','7 mg'],
                   ['32 clicks','8 mg'],['36 clicks','9 mg'],['40 clicks','10 mg'],
                   ['44 clicks','11 mg'],['48 clicks','12 mg'],['52 clicks','13 mg'],
                   ['56 clicks','14 mg'],['60 clicks','15 mg']]
          }
        ]
      },
      reta60: null,
      ghkcu: {
        title: 'GHK-Cu Click-to-Dose Chart',
        formatMatch: { '50mg': 0, '100mg': 1 },
        tabs: [
          {
            label: 'GHK-Cu 50mg',
            cols: ['Dose', 'Clicks'],
            rows: [['0.5 mg','3 clicks'],['1.0 mg','6 clicks'],['1.5 mg','9 clicks'],
                   ['2.0 mg','12 clicks'],['2.5 mg','15 clicks']]
          },
          {
            label: 'GHK-Cu 100mg',
            cols: ['Dose', 'Clicks'],
            rows: [['0.5 mg','2 clicks'],['1.0 mg','3 clicks'],['1.5 mg','5 clicks'],
                   ['2.0 mg','6 clicks'],['2.5 mg','8 clicks'],['3.0 mg','9 clicks'],
                   ['4.0 mg','12 clicks'],['5.0 mg','15 clicks']]
          }
        ]
      },
      motsc: {
        title: 'MOTS-C 40mg Click-to-Dose Chart',
        cols: ['Dose', 'Clicks'],
        rows: [['0.5 mg','3 clicks'],['1.0 mg','6 clicks'],['1.5 mg','9 clicks'],
               ['2.0 mg','12 clicks'],['2.5 mg','15 clicks'],['3.0 mg','18 clicks']],
        refChart: true
      },
      melanotan: {
        title: 'Melanotan-1 10mg Click-to-Dose Chart',
        cols: ['Dose', 'Clicks'],
        rows: [['50 mcg','1 click'],['100 mcg','2 clicks'],['200 mcg','4 clicks'],
               ['300 mcg','6 clicks'],['400 mcg','8 clicks']]
      },
      cjc: {
        title: 'CJC-1295 No DAC + Ipamorelin Click-to-Dose Chart',
        cols: ['Dose (each)', 'Clicks'],
        rows: [['25 mcg + 25 mcg','1 click'],['100 mcg + 100 mcg','4 clicks'],
               ['150 mcg + 150 mcg','6 clicks'],['200 mcg + 200 mcg','8 clicks'],
               ['250 mcg + 250 mcg','10 clicks'],['300 mcg + 300 mcg','12 clicks']]
      },

      /* ── CJC-1295 No DAC + Ipamorelin, keyed by the real product handle
         (safer than the legacy title-match above, which stays only as an
         unused fallback now). 10mg-total tab reuses the existing verified
         values from the 'cjc' entry above; 20mg-total is the new blend. ── */
      'cjc-1295-no-dac-ipamorlin': {
        title: 'CJC-1295 No DAC + Ipamorelin Click-to-Dose Chart',
        defaultTab: 0,
        formatMatch: { '10mg': 0, '20mg': 1 },
        tabs: [
          {
            label: '10MG TOTAL',
            cols: ['Clicks', 'Dose (each)'],
            rows: [['1 click','25 mcg + 25 mcg'],['4 clicks','100 mcg + 100 mcg'],
                   ['6 clicks','150 mcg + 150 mcg'],['8 clicks','200 mcg + 200 mcg'],
                   ['10 clicks','250 mcg + 250 mcg'],['12 clicks','300 mcg + 300 mcg']]
          },
          {
            label: '20MG TOTAL — 10MG + 10MG',
            tabTitle: 'CJC-1295 No DAC 10mg + Ipamorelin 10mg Click-to-Dose Chart',
            cols: ['Clicks', 'Dose'],
            rows: [['1 Click','50 mcg + 50 mcg'],['2 Clicks','100 mcg + 100 mcg'],
                   ['3 Clicks','150 mcg + 150 mcg'],['4 Clicks','200 mcg + 200 mcg'],
                   ['5 Clicks','250 mcg + 250 mcg'],['6 Clicks','300 mcg + 300 mcg']]
          }
        ]
      },

      /* ── BPC-157 + TB-500 BLEND (the combined product, distinct from the
         standalone BPC-157 10mg pen keyed separately below). Converted to a
         2-strength selector per the corrected 200-click / 2mL BAC-water
         calibration. The old 5mcg+5mcg / "10mg total" figures are retired —
         they do not appear anywhere in this data. ── */
      'bpc-157-5mg-tb500-5mg': {
        title: 'BPC-157 10mg + TB-500 10mg Click-to-Dose Chart',
        defaultTab: 1,
        formatMatch: { '10mg': 0, '20mg': 1 },
        tabs: [
          {
            label: '10MG TOTAL',
            cols: ['Clicks', 'Dose (each)'],
            rows: [['1 click','25 mcg + 25 mcg'],['4 clicks','100 mcg + 100 mcg'],
                   ['8 clicks','200 mcg + 200 mcg'],['10 clicks','250 mcg + 250 mcg'],
                   ['20 clicks','500 mcg + 500 mcg']]
          },
          {
            label: '20MG TOTAL — 10MG + 10MG',
            tabTitle: 'BPC-157 10mg + TB-500 10mg Click-to-Dose Chart',
            cols: ['Clicks', 'Dose (each)'],
            rows: [['1 click','50 mcg + 50 mcg'],['2 clicks','100 mcg + 100 mcg'],
                   ['4 clicks','200 mcg + 200 mcg'],['5 clicks','250 mcg + 250 mcg'],
                   ['10 clicks','500 mcg + 500 mcg']]
          }
        ]
      },

      /* ── New-stock click-to-dose charts, keyed by handle. refChart:true
         triggers the research-reference notices above/below the table.
         Click-to-compound-quantity references only — no doses, schedules,
         cycles or administration instructions are implied. ── */
      /* ──────────────────────────────────────────────────────────────
         GLP-3 product page.

         The compound in this pen is RETATRUTIDE, and every tab says so
         explicitly — "GLP-3" is the store listing name, not a compound
         name, and is never presented here as a scientific synonym.
         (For the record: GLP-1 and GLP-2 exist; GLP-3 does not.
         Retatrutide is a GLP-1 / GIP / glucagon triple agonist.)

         Deliberately a SEPARATE key from `reta` rather than a shared one,
         so the Retatrutide product page keeps its own existing chart
         untouched.

         Values are carried over from the existing Retatrutide tables.
         mg-per-click is derived from those tables; cartridge volume is
         stated only for the 10mg pen, which is the only strength with a
         supplied volume — nothing is invented for 30mg or 60mg.
      ────────────────────────────────────────────────────────────────── */
      'glp-3': {
        title: 'Retatrutide — Concentration Conversion Reference',
        defaultTab: 1,
        formatMatch: { '10mg': 0, '30mg': 1, '60mg': 2 },
        tabs: [
          {
            label: '10mg',
            tabTitle: 'Retatrutide 10mg — Concentration Conversion Reference',
            cols: ['Clicks', 'Dose'],
            rows: [['10 clicks','0.5 mg'],['20 clicks','1.0 mg'],['30 clicks','1.5 mg'],
                   ['40 clicks','2.0 mg'],['50 clicks','2.5 mg'],['60 clicks','3.0 mg']],
            note: 'Compound: Retatrutide. 10 mg total in 2 mL · 5 mg/mL · 1 click = 0.01 mL = 0.05 mg. Technical concentration reference only — not a recommended dosing protocol. Click volume must be verified against the pen manufacturer’s specifications.'
          },
          {
            label: '30mg',
            tabTitle: 'Retatrutide 30mg — Concentration Conversion Reference',
            cols: ['Clicks', 'Dose'],
            rows: [['8 clicks','1 mg'],['16 clicks','2 mg'],['24 clicks','3 mg'],
                   ['32 clicks','4 mg'],['40 clicks','5 mg'],['48 clicks','6 mg'],
                   ['56 clicks','7 mg'],['60 clicks','7.5 mg']],
            note: 'Compound: Retatrutide. 1 click = 0.125 mg, derived from the values above. Technical concentration reference only — not a recommended dosing protocol. Click volume must be verified against the pen manufacturer’s specifications.'
          },
          {
            label: '60mg',
            tabTitle: 'Retatrutide 60mg — Concentration Conversion Reference',
            cols: ['Clicks', 'Dose'],
            rows: [['8 clicks','2 mg'],['12 clicks','3 mg'],['16 clicks','4 mg'],
                   ['20 clicks','5 mg'],['24 clicks','6 mg'],['28 clicks','7 mg'],
                   ['32 clicks','8 mg'],['36 clicks','9 mg'],['40 clicks','10 mg'],
                   ['44 clicks','11 mg'],['48 clicks','12 mg'],['52 clicks','13 mg'],
                   ['56 clicks','14 mg'],['60 clicks','15 mg']],
            note: 'Compound: Retatrutide. 1 click = 0.25 mg, derived from the values above. Technical concentration reference only — not a recommended dosing protocol. Click volume must be verified against the pen manufacturer’s specifications.'
          }
        ]
      },
      'bpc-157-10mg': {
        title: 'BPC-157 10mg CLICK-TO-DOSE CHART',
        cols: ['Dose', 'Clicks'],
        rows: [['50mcg','1 click'],['100mcg','2 clicks'],['200mcg','4 clicks'],
               ['250mcg','5 clicks'],['400mcg','8 clicks']],
        refChart: true
      },
      'tesamorelin-20mg': {
        title: 'Tesamorelin Click-to-Dose Chart',
        defaultTab: 0,
        formatMatch: { '20mg': 0, '40mg': 1 },
        tabs: [
          {
            label: 'Tesamorelin 20mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.1mg'],['2 clicks','0.2mg'],['5 clicks','0.5mg'],
                   ['10 clicks','1mg'],['15 clicks','1.5mg'],['20 clicks','2mg']]
          },
          {
            label: 'Tesamorelin 40mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.2 mg'],['2 clicks','0.4 mg'],['5 clicks','1 mg'],
                   ['10 clicks','2 mg'],['15 clicks','3 mg'],['20 clicks','4 mg']]
          }
        ]
      },
      'klow-blend-80mg': {
        title: 'KLOW 80MG CLICK-TO-DOSE CHART',
        cols: ['Clicks', 'BPC-157', 'KPV', 'TB-500', 'GHK-Cu'],
        rows: [['1 click','0.05mg','0.05mg','0.05mg','0.25mg'],
               ['2 clicks','0.1mg','0.1mg','0.1mg','0.5mg'],
               ['5 clicks','0.25mg','0.25mg','0.25mg','1.25mg'],
               ['10 clicks','0.5mg','0.5mg','0.5mg','2.5mg'],
               ['15 clicks','0.75mg','0.75mg','0.75mg','3.75mg'],
               ['20 clicks','1mg','1mg','1mg','5mg']],
        wide: true,
        refChart: true
      },
      'ahk-cu-100mg': {
        title: 'AHK-Cu 100MG CLICK-TO-DOSE CHART',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','0.5mg'],['2 clicks','1mg'],['4 clicks','2mg'],
               ['8 clicks','4mg'],['10 clicks','5mg'],['12 clicks','6mg']],
        refChart: true
      },
      'slu-pp-332-10mg': {
        title: 'SLU-PP-332 10MG CLICK-TO-DOSE CHART',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','0.05mg'],['2 clicks','0.1mg'],['5 clicks','0.25mg'],
               ['10 clicks','0.5mg'],['15 clicks','0.75mg'],['20 clicks','1mg']],
        refChart: true
      },
      'glutathione-1500mg': {
        title: 'GLUTATHIONE 1500MG CLICK-TO-DOSE CHART',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','5mg'],['2 clicks','10mg'],['5 clicks','25mg'],
               ['10 clicks','50mg'],['15 clicks','75mg'],['20 clicks','100mg']],
        refChart: true
      },
      'kpv-10mg': {
        title: 'KPV Click-to-Dose Chart',
        defaultTab: 0,
        formatMatch: { '10mg': 0, '20mg': 1 },
        tabs: [
          {
            label: 'KPV 10mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','50mcg'],['2 clicks','100mcg'],['5 clicks','250mcg'],
                   ['10 clicks','500mcg'],['15 clicks','750mcg'],['20 clicks','1mg']]
          },
          {
            label: 'KPV 20mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','100 mcg'],['2 clicks','200 mcg'],['5 clicks','500 mcg'],
                   ['10 clicks','1 mg']]
          }
        ]
      },
      'aod-9604-5mg': {
        title: 'AOD-9604 5MG CLICK-TO-DOSE CHART',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','25mcg'],['2 clicks','50mcg'],['5 clicks','125mcg'],
               ['10 clicks','250mcg'],['15 clicks','375mcg'],['20 clicks','500mcg']],
        refChart: true
      },
      'ss-31-10mg': {
        title: 'SS-31 Click-to-Dose Chart',
        defaultTab: 0,
        formatMatch: { '10mg': 0, '25mg': 1, '50mg': 2 },
        tabs: [
          {
            label: 'SS-31 10mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.05mg'],['2 clicks','0.1mg'],['5 clicks','0.25mg'],
                   ['10 clicks','0.5mg'],['15 clicks','0.75mg'],['20 clicks','1mg']]
          },
          {
            label: 'SS-31 25mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.125 mg'],['2 clicks','0.25 mg'],['4 clicks','0.5 mg'],
                   ['8 clicks','1 mg'],['14 clicks','1.5 mg'],['18 clicks','2 mg']]
          },
          {
            label: 'SS-31 50mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.25 mg'],['2 clicks','0.5 mg'],['4 clicks','1 mg'],
                   ['6 clicks','1.5 mg'],['8 clicks','2 mg']]
          }
        ]
      },
      'igf-1-lr3-1mg': {
        title: 'IGF-1 LR3 Click-to-Dose Chart',
        defaultTab: 0,
        formatMatch: { '1mg': 0, '2mg': 1 },
        tabs: [
          {
            label: 'IGF-1 LR3 1mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','5mcg'],['2 clicks','10mcg'],['5 clicks','25mcg'],
                   ['10 clicks','50mcg'],['15 clicks','75mcg'],['20 clicks','100mcg']]
          },
          {
            label: 'IGF-1 LR3 2mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','10 mcg'],['2 clicks','20 mcg'],['5 clicks','50 mcg'],
                   ['10 clicks','100 mcg']]
          }
        ]
      },
      'nad-1000mg': {
        title: 'NAD+ 1000MG CLICK-TO-DOSE CHART',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','5mg'],['2 clicks','10mg'],['5 clicks','25mg'],
               ['10 clicks','50mg'],['15 clicks','75mg'],['20 clicks','100mg']],
        refChart: true
      },
      'semax-10mg-nasal-spray': {
        title: 'SEMAX 10mg SPRAY TO DOSE CHART',
        cols: ['Sprays', 'Dose'],
        rows: [['1 spray','200mcg'],['2 sprays','400mcg'],['3 sprays','600mcg'],['4 sprays','800mcg']],
        sprayChart: true
      },
      'selank-10mg-nasal-spray': {
        title: 'SELANK 10mg SPRAY TO DOSE CHART',
        cols: ['Sprays', 'Dose'],
        rows: [['1 spray','200mcg'],['2 sprays','400mcg'],['3 sprays','600mcg'],['4 sprays','800mcg']],
        sprayChart: true
      },

      /* ── New products this task, handles best-guessed from their titles
         (NOT verified live — no Shopify connection this turn). Flagged in
         the completion report; if either handle is wrong the button simply
         won't appear on that product, silently, so this needs a live check. ── */
      '5-amino-1mq': {
        title: '5-Amino-1MQ Click-to-Dose Chart',
        defaultTab: 0,
        formatMatch: { '50mg': 0, '100mg': 1 },
        tabs: [
          {
            label: '5-Amino-1MQ 50mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.25 mg'],['2 clicks','0.5 mg'],['4 clicks','1 mg'],
                   ['8 clicks','2 mg'],['12 clicks','3 mg']]
          },
          {
            label: '5-Amino-1MQ 100mg',
            cols: ['Clicks', 'Dose'],
            rows: [['1 click','0.5 mg'],['2 clicks','1 mg'],['4 clicks','2 mg'],
                   ['6 clicks','3 mg'],['8 clicks','4 mg']]
          }
        ]
      },
      'ghrp-6-10mg': {
        title: 'GHRP-6 10mg Click-to-Dose Chart',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','0.05 mg'],['2 clicks','0.1 mg'],['5 clicks','0.25 mg'],
               ['10 clicks','0.5 mg'],['20 clicks','1 mg']],
        refChart: true
      },
      'pt-141': {
        title: 'PT-141 10mg Click-to-Dose Chart',
        cols: ['Clicks', 'Dose'],
        rows: [['1 click','0.05 mg'],['2 clicks','0.1 mg'],['5 clicks','0.25 mg'],
               ['10 clicks','0.5 mg'],['20 clicks','1 mg']],
        refChart: true
      },
      'kisspeptin-10mg': {
        title: 'Kisspeptin 10mg Click-to-Dose Chart',
        cols: ['Clicks', 'Dose'],
        /* Source PDF error corrected: 20 clicks read as 0.1mg there, which
           breaks the chart's own 0.05mg-per-click calibration (1 click =
           0.05mg → 20 clicks = 1mg, not 0.1mg). Displayed value fixed to
           1mg; nothing else in the calibration was changed. */
        rows: [['1 click','0.05 mg'],['2 clicks','0.1 mg'],['5 clicks','0.25 mg'],
               ['10 clicks','0.5 mg'],['15 clicks','0.75 mg'],['20 clicks','1 mg']],
        refChart: true
      }
    };

    function buildTable(tab) {
      var h = tab.cols.map(function(c){return '<th>'+c+'</th>';}).join('');
      var b = tab.rows.map(function(r){
        return '<tr>'+r.map(function(c){return '<td>'+c+'</td>';}).join('')+'</tr>';
      }).join('');
      return '<table class="dc-table"><thead><tr>'+h+'</tr></thead><tbody>'+b+'</tbody></table>';
    }

    function buildRefChart(chart, pdfUrl) {
      var notice = 'RESEARCH REFERENCE ONLY — NOT FOR HUMAN OR VETERINARY USE';
      var explain = 'This chart shows the relationship between the supplied research pen\u2019s click settings and compound quantity. It does not provide a recommended dose, treatment protocol, administration schedule or medical advice.';
      var html = '<p class="dc-ref-notice">' + notice + '</p>';
      html += '<div class="dc-table-scroll' + (chart.wide ? ' dc-table-scroll--wide' : '') + '">' + buildTable(chart) + '</div>';
      html += '<p class="dc-ref-notice">' + notice + '</p>';
      html += '<p class="dc-ref-explain">' + explain + '</p>';
      if (pdfUrl) {
        html += '<div class="pdf-dc-actions dc-ref-actions">' +
                  '<a href="' + pdfUrl + '" target="_blank" rel="noopener" class="pdf-dc-open-btn">OPEN FULL PDF</a>' +
                  '<a href="' + pdfUrl + '" download class="pdf-dc-download-btn">DOWNLOAD PDF</a>' +
                '</div>';
      }
      return html;
    }

    function buildTabbed(chart, startTab) {
      var activeIdx = startTab !== undefined ? startTab : 0;
      var tabBtns = chart.tabs.map(function(t, i) {
        return '<button class="dc-tab-btn'+(i===activeIdx?' dc-tab-btn--active':'')+'" role="tab" aria-selected="'+(i===activeIdx?'true':'false')+'" id="dc-tab-'+i+'" aria-controls="dc-panel-'+i+'" data-tab="'+i+'">'+t.label+'</button>';
      }).join('');
      var panels = chart.tabs.map(function(t, i) {
        // Optional per-tab note, rendered under that tab's table only. Tabs
        // without a `note` are unaffected, so adding one to a single strength
        // never changes the other strengths' panels.
        var note = t.note ? '<p class="dc-ref-explain dc-tab-note">'+t.note+'</p>' : '';
        return '<div class="dc-tab-panel'+(i===activeIdx?' dc-tab-panel--active':'')+'" role="tabpanel" id="dc-panel-'+i+'" aria-labelledby="dc-tab-'+i+'" data-panel="'+i+'"><div class="dc-table-scroll">'+buildTable(t)+'</div>'+note+'</div>';
      }).join('');
      return '<div class="dc-tabs"><div class="dc-tab-btns" role="tablist" aria-label="Select strength">'+tabBtns+'</div>'+panels+'</div>';
    }

    function buildSprayChart(chart) {
      var html = '<div class="dc-table-scroll">' + buildTable(chart) + '</div>';
      html += '<p class="dc-ref-explain dc-spray-note">Laboratory conversion reference only. Not dosing advice. Not intended for human or veterinary use.</p>';
      return html;
    }

    function openChart(key, startTab, pdfUrl) {
      var chart  = CHARTS[key];
      var modal  = document.getElementById('dose-chart-modal');
      var titleEl= document.getElementById('dc-title');
      var bodyEl = document.getElementById('dc-body');
      if (!chart || !modal) return;
      var tabIdx = (startTab !== undefined) ? startTab : (chart.defaultTab || 0);
      if (titleEl) {
        titleEl.textContent = (chart.tabs && chart.tabs[tabIdx])
          ? (chart.tabs[tabIdx].tabTitle || (chart.tabs[tabIdx].label + ' Click-to-Dose Chart'))
          : chart.title;
      }
      if (bodyEl) {
        if (chart.sprayChart) {
          bodyEl.innerHTML = buildSprayChart(chart);
        } else if (chart.refChart) {
          bodyEl.innerHTML = buildRefChart(chart, pdfUrl);
        } else {
          bodyEl.innerHTML = chart.tabs ? buildTabbed(chart, tabIdx) : '<div class="dc-table-scroll">' + buildTable(chart) + '</div>';
        }
        // Required disclaimer, shown below every chart of every type.
        bodyEl.innerHTML += '<p class="dc-standard-disclaimer">Research reference only. Not intended as medical guidance or for human use.</p>';
      }
      document.documentElement.setAttribute('data-modal-open', '');
      modal.style.display = 'flex';
      modal.dataset.chartKey = key; // so in-modal tab switches can look up per-tab titles
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          modal.classList.add('open');
          modal.setAttribute('aria-hidden', 'false');
        });
      });
    }

    function closeChart() {
      var modal = document.getElementById('dose-chart-modal');
      if (!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('data-modal-open');
      setTimeout(function() {
        if (!modal.classList.contains('open')) modal.style.display = 'none';
      }, 220);
    }

    // Exposed so the variant-switch module (a separate closure) can look up
    // chart format-match data and trigger a live in-place chart update when
    // the modal is already open while the customer changes format/strength.
    window.__DOSE_CHARTS__ = CHARTS;
    window.__openDoseChart__ = openChart;
    window.__closeDoseChart__ = closeChart;

    /* Tab switching — delegated */
    document.addEventListener('click', function(e) {
      /* Dose chart open */
      var btn = e.target.closest('.pdp-dose-btn');
      if (btn) { e.preventDefault(); openChart(btn.dataset.chart, btn.dataset.chartTab ? parseInt(btn.dataset.chartTab) : undefined, btn.dataset.pdfUrl || undefined); return; }

      /* Tab switch */
      var tabBtn = e.target.closest('.dc-tab-btn');
      if (tabBtn) {
        var idx = tabBtn.dataset.tab;
        var bodyEl = document.getElementById('dc-body');
        var modalEl = document.getElementById('dose-chart-modal');
        if (!bodyEl) return;
        bodyEl.querySelectorAll('.dc-tab-btn').forEach(function(b) { b.classList.remove('dc-tab-btn--active'); b.setAttribute('aria-selected', 'false'); });
        bodyEl.querySelectorAll('.dc-tab-panel').forEach(function(p) { p.classList.remove('dc-tab-panel--active'); });
        tabBtn.classList.add('dc-tab-btn--active');
        tabBtn.setAttribute('aria-selected', 'true');
        var panel = bodyEl.querySelector('.dc-tab-panel[data-panel="'+idx+'"]');
        if (panel) panel.classList.add('dc-tab-panel--active');
        // Update the visible chart title to the specific strength selected
        var titleEl2 = document.getElementById('dc-title');
        var activeChart = modalEl ? CHARTS[modalEl.dataset.chartKey] : null;
        if (titleEl2 && activeChart && activeChart.tabs && activeChart.tabs[idx]) {
          titleEl2.textContent = activeChart.tabs[idx].tabTitle || (activeChart.tabs[idx].label + ' Click-to-Dose Chart');
        }
        return;
      }

      /* Close */
      if (e.target.closest('#dc-close')) { closeChart(); return; }
      var modal = document.getElementById('dose-chart-modal');
      if (modal && modal.classList.contains('open') && e.target === modal) closeChart();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var modal = document.getElementById('dose-chart-modal');
      if (modal && modal.classList.contains('open')) closeChart();
    });
  })();

  /* ════════════════════════════════
     PDF DOSE CHART MODAL — embeds the original assigned PDF, lazy-loaded
     only after the modal opens. Independent of the click-table system
     above so it never interferes with Retatrutide/GHK-Cu/MOTS-C/CJC/
     Melanotan/BPC-157+TB-500 charts.
     ════════════════════════════════ */
  (function pdfDoseChart() {
    var modal = document.getElementById('pdf-dose-modal');
    if (!modal) return;

    var frame = modal.querySelector('.pdf-dc-frame');
    var openBtn = modal.querySelector('.pdf-dc-open-btn');
    var downloadBtn = modal.querySelector('.pdf-dc-download-btn');
    var lastFocused = null;

    function focusableEls() {
      return Array.prototype.slice.call(
        modal.querySelectorAll('button, a[href], iframe')
      );
    }

    function openPdfModal(btn) {
      var url = btn.getAttribute('data-pdf-url');
      var title = btn.getAttribute('data-pdf-title');
      if (!url) return;

      lastFocused = btn;
      if (title) {
        var titleEl = document.getElementById('pdf-dc-title');
        if (titleEl) titleEl.textContent = title + ' — CLICK-TO-DOSE CHART';
      }

      /* Lazy-load: only set iframe src once, when opened */
      if (!frame.getAttribute('src')) frame.setAttribute('src', url);
      if (openBtn) openBtn.setAttribute('href', url);
      if (downloadBtn) downloadBtn.setAttribute('href', url);

      modal.style.display = 'flex';
      requestAnimationFrame(function () { modal.classList.add('open'); });
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      modal.setAttribute('aria-hidden', 'false');

      var els = focusableEls();
      if (els.length) els[0].focus();
    }

    function closePdfModal() {
      modal.classList.remove('open');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      modal.setAttribute('aria-hidden', 'true');
      setTimeout(function () { modal.style.display = 'none'; }, 200);
      if (lastFocused) lastFocused.focus();
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdf-dose-btn');
      if (btn) { openPdfModal(btn); return; }

      if (e.target.closest('#pdf-dc-close')) { closePdfModal(); return; }
      if (e.target === modal && modal.classList.contains('open')) closePdfModal();
    });

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('open')) return;

      if (e.key === 'Escape') { closePdfModal(); return; }

      /* Focus trap */
      if (e.key === 'Tab') {
        var els = focusableEls();
        if (!els.length) return;
        var first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });

    /* Mobile fallback: if the iframe fails to render a PDF, show the
       branded fallback icon + OPEN FULL PDF button instead. */
    frame.addEventListener('error', function () {
      modal.querySelector('.pdf-dc-frame-wrap').classList.add('pdf-dc-frame-wrap--fallback');
    });
  })();

  /* ════════════════════════════════
     QUANTITY STEPPER
  ════════════════════════════════ */
  $$('.pdp-qbtn').forEach(btn => {
    on(btn, 'click', () => {
      const wrap = btn.closest('.pdp-qty');
      const inp = wrap ? wrap.querySelector('.pdp-qinp') : null;
      if (!inp) return;
      const next = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(btn.dataset.d, 10));
      inp.value = next;
    });
  });

  /* ════════════════════════════════
     ADD TO CART — real Shopify AJAX endpoint
     Includes optional 50 Needle Heads add-on (GHK-Cu page only)
  ════════════════════════════════ */

  /* ── Add-on checkbox UI ── */
  (function addonCheckbox() {
    const check = $('#addon-check');
    const box   = $('#addon-check-box');
    const card  = $('#addon-card');
    if (!check || !box) return;
    check.addEventListener('change', function() {
      const c = check.checked;
      box.innerHTML = c
        ? '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round"><polyline points="2,8 6,12 14,4"/></svg>'
        : '';
      box.classList.toggle('addon-check-box--checked', c);
      if (card) card.classList.toggle('addon-card--selected', c);
    });
  })();

  /* Needle heads Shopify variant ID — read from the DOM so it's always live */
  function getNeedleVid() {
    /* Primary: data attribute injected by Liquid */
    const el = document.getElementById('addon-section');
    if (el && el.dataset.needleVid) return el.dataset.needleVid;
    return null;
  }

  async function addNeedleHeads() {
    /* Fallback: search cart for 50-needle-heads handle first to avoid dupes */
    const cartRes = await fetch('/cart.js');
    const cart    = await cartRes.json();
    const already = cart.items.some(i => i.handle === '50-needle-heads');
    if (already) return; /* don't add twice */

    /* Try variant ID from DOM first, then search by handle */
    let vid = getNeedleVid();
    if (!vid) {
      const prodRes = await fetch('/products/50-needle-heads.js');
      if (!prodRes.ok) throw new Error('Needle heads product not found');
      const prod = await prodRes.json();
      vid = prod.variants[0].id;
    }
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add needle heads');
    }
  }

  const pdpForm = $('#pdp-product-form');
  if (pdpForm) {
    on(pdpForm, 'submit', async (e) => {
      e.preventDefault();
      const btn   = $('#pdp-atc-btn');
      const label = $('#pdp-atc-label');
      if (!btn || btn.disabled) return;

      const addonCheck = $('#addon-check');
      const wantsAddon = addonCheck && addonCheck.checked;

      const orig = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = wantsAddon ? 'ADDING ITEMS…' : 'ADDING…';

      try {
        /* 1. Add main product */
        const formData = new FormData(pdpForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          throw new Error(errBody.description || 'Could not add to cart');
        }

        /* 2. Add needle heads if checked */
        if (wantsAddon) {
          await addNeedleHeads();
        }

        if (label) label.textContent = 'ADDED ✓';
        await renderDrawer();
        setTimeout(openDrawer, 250);
      } catch (err) {
        console.error('Add to cart failed:', err);
        if (label) label.textContent = 'ERROR — TRY AGAIN';
      } finally {
        setTimeout(() => {
          btn.disabled = false;
          if (label) label.textContent = orig;
        }, 2200);
      }
    });
  }

  /* ════════════════════════════════
     BUY NOW — adds then sends straight to Shopify checkout
  ════════════════════════════════ */
  const buyNowBtn = $('#pdp-buy-now');
  if (buyNowBtn) {
    on(buyNowBtn, 'click', async () => {
      if (buyNowBtn.disabled) return;
      const orig = buyNowBtn.textContent;
      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'PROCESSING…';

      try {
        const formData = new FormData(pdpForm);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) {
          const errBody = await res.json().catch(() => ({}));
          throw new Error(errBody.description || 'Could not add to cart');
        }
        window.location.href = '/checkout';
      } catch (err) {
        console.error('Buy now failed:', err);
        buyNowBtn.textContent = 'ERROR — TRY AGAIN';
        setTimeout(() => {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = orig;
        }, 2200);
      }
    });
  }

  /* ════════════════════════════════
     SCROLL — STICKY HEADER
  ════════════════════════════════ */
  const hdr = $('#site-header');
  on(window, 'scroll', () => {
    if (hdr) hdr.style.background = window.scrollY > 10 ? 'rgba(0,0,0,0.98)' : 'rgba(12,12,12,0.85)';
  }, { passive: true });

  /* ════════════════════════════════
     FADE-IN ON SCROLL
  ════════════════════════════════ */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (!e.isIntersecting) return;
        setTimeout(() => {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
        }, i * 70);
        io.unobserve(e.target);
      });
    }, { threshold: 0.08 });

    $$('.feat, .pp-card, .pdp-feats li').forEach(el => {
      el.style.cssText += ';opacity:0;transform:translateY(14px);transition:opacity 0.55s ease,transform 0.55s ease';
      io.observe(el);
    });

    // About page reveal-on-scroll
    const apIo = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in-view');
          apIo.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    $$('.ap-reveal').forEach(el => apIo.observe(el));
  }

  /* ════════════════════════════════
     ABOUT LINK — smart anchor scroll
     Works identically on desktop, mobile, and iPad.
     - If #about already exists on the current page, smooth-scroll to it.
     - If not (e.g. clicked from /collections/all or /products/x),
       the browser navigates to "/#about" and this same handler runs
       again after the new page loads, scrolling to it there.
     This guarantees About never silently bounces back to a blank
     homepage top — it always lands exactly on the About content.
  ════════════════════════════════ */
  function scrollToAboutIfPresent() {
    if (window.location.hash !== '#about') return;
    const target = document.getElementById('about');
    if (!target) return;
    // Defer slightly so layout/fonts/images have settled (important on mobile Safari/iPad)
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
  }

  $$('.js-about-link').forEach(link => {
    on(link, 'click', (e) => {
      const targetOnPage = document.getElementById('about');
      if (targetOnPage) {
        // Already on a page that has #about — scroll directly, no page reload
        e.preventDefault();
        targetOnPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.pushState(null, '', '/#about');
        // Close mobile menu if open
        if (mNav && mNav.classList.contains('open')) {
          mNav.classList.remove('open');
          if (mBtn) mBtn.setAttribute('aria-expanded', 'false');
          mNav.setAttribute('aria-hidden', 'true');
        }
      }
      // Otherwise let the browser navigate normally to "/#about"
    });
  });

  // On initial page load, if URL already has #about (e.g. user followed
  // a link from another page), scroll to it once content is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scrollToAboutIfPresent);
  } else {
    scrollToAboutIfPresent();
  }
  on(window, 'load', scrollToAboutIfPresent);

  /* ════════════════════════════════
     AGE VERIFICATION GATE
     - Blocks the site until confirmed (no X / no escape)
     - Stores confirmation 30 days via localStorage + cookie fallback
     - "Exit" redirects to Google
  ════════════════════════════════ */
  (function ageGate() {
    const STORAGE_KEY = 'cp_age_verified';
    const DAYS = 30;

    function setVerified() {
      try {
        if (window.localStorage) localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) { /* localStorage unavailable (private mode etc.) — cookie still covers it */ }

      // Cookie fallback / cross-check, expires in 30 days
      const d = new Date();
      d.setTime(d.getTime() + DAYS * 24 * 60 * 60 * 1000);
      document.cookie = STORAGE_KEY + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
    }

    function isVerified() {
      try {
        if (window.localStorage && localStorage.getItem(STORAGE_KEY) === '1') return true;
      } catch (e) {}
      const match = document.cookie.match(/(?:^|; )cp_age_verified=([^;]*)/);
      return !!(match && match[1] === '1');
    }

    const gate = $('#age-gate');
    const wrap = $('#site-content-wrap');
    const confirmBtn = $('#age-gate-confirm');
    const exitBtn = $('#age-gate-exit');

    if (!gate) return;

    // Already verified within last 30 days — remove gate entirely, no flash.
    if (isVerified()) {
      gate.remove();
      document.documentElement.classList.remove('age-gate-pending');
      document.documentElement.classList.add('age-verified');
      if (wrap) { wrap.style.filter = 'none'; wrap.style.pointerEvents = 'auto'; }
      return;
    }

    // Not verified — keep page blurred/dimmed and inert until a choice is made.
    document.documentElement.classList.remove('age-verified');
    document.documentElement.classList.add('age-gate-pending');
    document.body.style.overflow = 'hidden'; // prevent background scroll while gated

    on(confirmBtn, 'click', () => {
      setVerified();
      gate.classList.add('age-gate-closing');
      if (wrap) wrap.classList.add('age-unlocking');
      document.documentElement.classList.remove('age-gate-pending');
      document.documentElement.classList.add('age-verified');
      document.body.style.overflow = '';
      setTimeout(() => gate.remove(), 480);
    });

    on(exitBtn, 'click', () => {
      window.location.href = 'https://www.google.com';
    });

    // No keyboard escape — block Esc from doing anything while gated
    on(document, 'keydown', (e) => {
      if (!document.documentElement.classList.contains('age-gate-pending')) return;
      if (e.key === 'Escape') e.preventDefault();
    });
  })();

  /* ════════════════════════════════
     WHATSAPP BACK-IN-STOCK NOTIFY ME
  ════════════════════════════════ */
  (function notifyMe() {
    var P = window.__NOTIFY_PRODUCT__;
    if (!P) return;

    var notifyBtn    = $('#pdp-notify-btn');
    var buyRow       = $('#pdp-buy-row');
    var buyNow       = $('#pdp-buy-now');
    var modal        = $('#notify-modal');
    var closeBtn     = $('#notify-close');
    var form         = $('#notify-form');
    var confirmDiv   = $('#notify-confirm');
    var confirmText  = $('#notify-confirm-text');
    var continueBtn  = $('#notify-continue');
    var phoneInput   = $('#notify-phone');
    var countryCode  = $('#notify-country-code');
    var consentCheck = $('#notify-consent');
    var consentLabel = $('#notify-consent-label');
    var consentBox   = $('#notify-consent-box');
    var phoneError   = $('#notify-phone-error');
    var consentError = $('#notify-consent-error');
    var submitBtn    = $('#notify-submit');
    var currentVid   = null;

    var DUPE_KEY = 'cp_notify_regs';
    function getRegs() { try { return JSON.parse(localStorage.getItem(DUPE_KEY)||'[]'); } catch(e){ return []; } }
    function addReg(vid,phone){ var r=getRegs(); r.push({vid:String(vid),phone:phone,ts:Date.now()}); try{localStorage.setItem(DUPE_KEY,JSON.stringify(r));}catch(e){} }
    function isDupe(vid,phone){ return getRegs().some(function(r){return r.vid===String(vid)&&r.phone===phone;}); }

    function normalisePhone(code,raw){
      var n=raw.replace(/[\s\-\(\)]/g,'');
      if(n.charAt(0)==='0') n=n.slice(1);
      if(!/^\d{7,14}$/.test(n)) return null;
      return code+n;
    }

    function updateSoldOutUI(available){
      if(!available){
        if(buyRow) buyRow.style.display='none';
        if(buyNow) buyNow.style.display='none';
        if(notifyBtn) notifyBtn.style.display='';
      } else {
        if(buyRow) buyRow.style.display='';
        if(buyNow) buyNow.style.display='';
        if(notifyBtn) notifyBtn.style.display='none';
      }
    }

    // Init from page-load variant
    var varSel = $('#pdp-variant-select');
    if(varSel){
      var initVid = parseInt(varSel.value);
      if(initVid && P.variantData[initVid]){
        currentVid=initVid;
        updateSoldOutUI(P.variantData[initVid].available);
      }
      varSel.addEventListener('change',function(){
        var vid=parseInt(varSel.value);
        if(P.variantData[vid]){ currentVid=vid; updateSoldOutUI(P.variantData[vid].available); }
      });
    }

    function showError(el,msg){if(el){el.textContent=msg;el.style.display='';}}
    function hideError(el){if(el){el.style.display='none';}}

    function openModal(){
      if(!modal) return;
      var vd = currentVid && P.variantData[currentVid];
      var img=$('#notify-product-img'), name=$('#notify-product-name'), vname=$('#notify-product-variant');
      if(img)   img.src=(vd&&vd.img)?vd.img:P.img;
      if(name)  name.textContent=P.title;
      if(vname) vname.textContent=vd?vd.title:'';
      var flds={'#notify-vid':currentVid||'','#notify-pid':P.id,'#notify-purl':P.url,'#notify-pname':P.title,'#notify-vname':vd?vd.title:''};
      Object.keys(flds).forEach(function(s){var el=$(s);if(el)el.value=flds[s];});
      if(form) form.style.display='';
      if(confirmDiv) confirmDiv.style.display='none';
      if(phoneInput) phoneInput.value='';
      if(consentCheck) consentCheck.checked=false;
      if(consentBox) consentBox.innerHTML='';
      if(consentLabel) consentLabel.classList.remove('notify-consent-wrap--checked');
      hideError(phoneError); hideError(consentError);
      modal.style.display='flex';
      document.documentElement.setAttribute('data-modal-open','');
      requestAnimationFrame(function(){requestAnimationFrame(function(){
        modal.classList.add('open');
        modal.setAttribute('aria-hidden','false');
        if(phoneInput) phoneInput.focus();
      });});
    }

    function closeModal(){
      if(!modal) return;
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden','true');
      document.documentElement.removeAttribute('data-modal-open');
      setTimeout(function(){if(!modal.classList.contains('open'))modal.style.display='none';},220);
    }

    if(form){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var ok=true;
        var code=(countryCode?countryCode.value:'+971');
        var raw=(phoneInput?phoneInput.value.trim():'');
        var fullPhone=normalisePhone(code,raw);
        if(!fullPhone){showError(phoneError,'Please enter a valid phone number (7–14 digits).');ok=false;}else{hideError(phoneError);}
        if(!consentCheck||!consentCheck.checked){showError(consentError,'Please accept to continue.');ok=false;}else{hideError(consentError);}
        if(!ok) return;
        var vid=($('#notify-vid')||{}).value, pname=($('#notify-pname')||{}).value,
            vname=($('#notify-vname')||{}).value, purl=($('#notify-purl')||{}).value,
            pid=($('#notify-pid')||{}).value;
        if(isDupe(vid,fullPhone)){showError(phoneError,"You're already registered. We'll notify you when it's back.");return;}
        if(submitBtn){submitBtn.disabled=true;submitBtn.textContent='Registering…';}
        fetch('/apps/notify-restock',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({phone:fullPhone,product_id:pid,product_name:pname,variant_id:vid,variant_name:vname,product_url:purl,consent:true,registered_at:new Date().toISOString()})
        }).catch(function(){return {ok:false};}).then(function(){
          addReg(vid,fullPhone);
          try{var p=JSON.parse(localStorage.getItem('cp_notify_pending')||'[]');
            p.push({phone:fullPhone,product_id:pid,product_name:pname,variant_id:vid,variant_name:vname,product_url:purl,registered_at:new Date().toISOString()});
            localStorage.setItem('cp_notify_pending',JSON.stringify(p));}catch(e2){}
          if(form) form.style.display='none';
          if(confirmDiv) confirmDiv.style.display='';
          if(confirmText) confirmText.textContent='We\'ll notify you on WhatsApp when '+pname+(vname?' – '+vname:'')+' is available again.';
          if(submitBtn){submitBtn.disabled=false;}
        });
      });
    }

    if(consentCheck){
      consentCheck.addEventListener('change',function(){
        var c=consentCheck.checked;
        if(consentLabel) consentLabel.classList.toggle('notify-consent-wrap--checked',c);
        if(consentBox) consentBox.innerHTML=c?'<svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="#000" stroke-width="2.5" stroke-linecap="round"><polyline points="2,8 6,12 14,4"/></svg>':'';
        if(c) hideError(consentError);
      });
    }
    if(phoneInput){ phoneInput.addEventListener('input',function(){ phoneInput.value=phoneInput.value.replace(/[^\d\s\-\(\)]/g,''); hideError(phoneError); }); }

    on(notifyBtn,'click',openModal);
    on(closeBtn,'click',closeModal);
    on(continueBtn,'click',closeModal);
    on(modal,'click',function(e){if(e.target===modal)closeModal();});
    on(document,'keydown',function(e){if(e.key==='Escape'&&modal&&modal.classList.contains('open'))closeModal();});
  })();

  /* ════════════════════════════════
     SHOP BY RESEARCH AREA — mobile pagination dots
     Generated dynamically to match however many cards actually rendered
     (server-side visibility rules already hid empty/disabled ones), and
     kept in sync with scroll position via IntersectionObserver so it
     degrades gracefully if unsupported (dots just don't update).
     ════════════════════════════════ */
  (function researchAreaNav() {
    var wraps = $$('.ran-wrap');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var carousel = $('.ran-carousel', wrap);
      var track = $('.ran-track', wrap);
      var dotsWrap = $('.ran-dots', wrap);
      if (!carousel || !track || !dotsWrap) return;

      var cards = $$('.ran-card', track);
      if (cards.length <= 1) return; // nothing to paginate

      cards.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ran-dot' + (i === 0 ? ' ran-dot--active' : '');
        dot.setAttribute('aria-label', 'Go to card ' + (i + 1));
        dot.addEventListener('click', function () {
          cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsWrap.appendChild(dot);
      });

      var dots = $$('.ran-dot', dotsWrap);

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = cards.indexOf(entry.target);
              if (idx === -1) return;
              dots.forEach(function (d, i) { d.classList.toggle('ran-dot--active', i === idx); });
            }
          });
        }, { root: carousel, threshold: 0.6 });
        cards.forEach(function (c) { observer.observe(c); });
      }
    });
  })();

  /* ════════════════════════════════
     Compact collection-tab row (Products page) — same-page filtering via
     Shopify's Section Rendering API (?section_id=...). No custom endpoint,
     no hardcoded product cards: every fetch re-renders the real section
     Liquid for the target collection, server-side, exactly like a normal
     page load would.
     ════════════════════════════════ */
  (function productsPageTabs() {
    var tabsNav = $('#pp-tabs');
    var region  = $('#pp-ajax-region');
    if (!tabsNav || !region) return;

    var sectionId = region.dataset.sectionId;
    if (!sectionId) return;

    var cache = {}; // fetched innerHTML per URL, session-lived only

    // Visually-hidden live region for screen-reader loading announcements
    var live = document.createElement('div');
    live.setAttribute('aria-live', 'polite');
    live.className = 'visually-hidden';
    live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;';
    document.body.appendChild(live);

    function setActiveTab(handle) {
      $$('.pp-tab', tabsNav).forEach(function (t) {
        var active = t.dataset.collectionHandle === handle;
        t.classList.toggle('pp-tab--active', active);
        if (active) t.setAttribute('aria-current', 'page');
        else t.removeAttribute('aria-current');
      });
    }

    function swapRegion(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('pp-ajax-region');
      if (fresh) region.innerHTML = fresh.innerHTML;
    }

    function loadCollection(url, handle, pushHistory) {
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

      if (pushHistory !== false) {
        window.history.pushState({ ppTabUrl: url, ppTabHandle: handle }, '', url);
      }
      setActiveTab(handle);

      if (cache[fetchUrl]) {
        swapRegion(cache[fetchUrl]);
        return;
      }

      region.classList.add('pp-ajax-region--loading');
      region.setAttribute('aria-busy', 'true');
      live.textContent = 'Loading products…';

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          cache[fetchUrl] = html;
          swapRegion(html);
          live.textContent = 'Products updated.';
        })
        .catch(function () {
          // Fall back to a normal navigation if the fetch fails for any reason
          window.location = url;
        })
        .finally(function () {
          region.classList.remove('pp-ajax-region--loading');
          region.removeAttribute('aria-busy');
        });
    }

    on(tabsNav, 'click', function (e) {
      var tab = e.target.closest('.pp-tab');
      if (!tab) return;
      // Let modified clicks (cmd/ctrl/middle-click) behave normally
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      loadCollection(tab.getAttribute('href'), tab.dataset.collectionHandle, true);
    });

    on(window, 'popstate', function (e) {
      var state = e.state;
      if (state && state.ppTabUrl) {
        loadCollection(state.ppTabUrl, state.ppTabHandle, false);
      } else {
        // Landed back on the original entry (no state) — reload normally
        // rather than guessing, since we can't reconstruct the exact tab.
        window.location.reload();
      }
    });

    // Record initial state so the very first popstate back to this exact
    // page has something to restore instead of falling through to reload.
    var initialTab = $('.pp-tab--active', tabsNav);
    if (initialTab && window.history.replaceState) {
      window.history.replaceState(
        { ppTabUrl: initialTab.getAttribute('href'), ppTabHandle: initialTab.dataset.collectionHandle },
        '', window.location.href
      );
    }
  })();

  /* ════════════════════════════════
     Header predictive search — Shopify's native /search/suggest.json
     endpoint. No hardcoded product data; every result comes live from
     Shopify. Desktop: persistent bar beside nav. Mobile: icon toggles a
     full-width overlay bar. Same component, same JS, different CSS layout.
     Debounced fetch, animated dropdown, skeleton loading, full arrow-key
     navigation, stale-response guarding.
     ════════════════════════════════ */
  (function headerSearch() {
    var wrap    = $('#hdr-search-wrap');
    var toggle  = $('#hdr-search-toggle');
    var bar     = $('#hdr-search-bar');
    var input   = $('#hdr-search-input');
    var closeBtn= $('#hdr-search-close');
    var results = $('#hdr-search-results');
    if (!wrap || !input || !results) return;

    var viewAllText  = input.dataset.viewAllText || 'View all results';
    var noResultsText= input.dataset.noResultsText || 'No matching products found.';
    var soldOutText  = input.dataset.soldOutText || 'Sold out';
    var inStockText  = input.dataset.inStockText || 'In stock';
    var searchUrl    = input.dataset.searchUrl || '/search';

    var debounceTimer = null;
    var currentQuery = '';
    var lastFocused = null;
    var activeIndex = -1; // -1 = input itself has focus, no item highlighted
    var fetchAbort = null;

    /* ── Alias map: normalized (lowercase, no spaces/hyphens/slashes) key →
       canonical product name text sent to Shopify's own search instead.
       Longest key first so e.g. "ghkcu" is checked before "ghk". ── */
    var ALIASES = [
      { key: 'ghkcu', canonical: 'GHK-Cu' }, { key: 'ghk', canonical: 'GHK-Cu' },
      { key: 'motsc', canonical: 'MOTS-c' }, { key: 'mots', canonical: 'MOTS-c' },
      { key: 'reta', canonical: 'Retatrutide' },
      { key: 'cjcipamorelin', canonical: 'CJC-1295 Ipamorelin' },
      { key: 'cjcipa', canonical: 'CJC-1295 Ipamorelin' },
      { key: 'bpc157tb500', canonical: 'BPC-157 TB-500' },
      { key: 'bpctb500', canonical: 'BPC-157 TB-500' },
      { key: 'ss31', canonical: 'SS-31' },
      { key: 'igf1lr3', canonical: 'IGF-1 LR3' }, { key: 'igf1', canonical: 'IGF-1 LR3' }, { key: 'igf', canonical: 'IGF-1 LR3' },
      { key: 'pt141', canonical: 'PT-141' },
      { key: '5amino1mq', canonical: '5-Amino-1MQ' }, { key: '5amino', canonical: '5-Amino-1MQ' }, { key: '1mq', canonical: '5-Amino-1MQ' },
      { key: 'melanotanii', canonical: 'Melanotan II' }, { key: 'melanotan2', canonical: 'Melanotan II' }, { key: 'mt2', canonical: 'Melanotan II' },
      { key: 'ghrp6', canonical: 'GHRP-6' }
    ].sort(function (a, b) { return b.key.length - a.key.length; });

    // Lowercase, strip spaces/hyphens/slashes — makes "SS-31", "ss 31" and
    // "ss/31" all compare equal, as required.
    function normalize(s) { return (s || '').toLowerCase().replace(/[\s\-\/]+/g, ''); }

    // Resolves an alias prefix in the query to its canonical product name.
    // Returns both the text to send to Shopify AND the remainder (whatever
    // came after the alias) separately, so strength-token extraction never
    // has to scan through the alias's own digits (e.g. the "31" in "ss31"
    // bleeding into a "25mg" that follows it).
    function resolveQuery(raw) {
      var norm = normalize(raw);
      for (var i = 0; i < ALIASES.length; i++) {
        var a = ALIASES[i];
        if (norm.indexOf(a.key) === 0) {
          var remainder = norm.slice(a.key.length);
          return { search: (a.canonical + ' ' + remainder).trim(), remainder: remainder };
        }
      }
      return { search: raw, remainder: norm };
    }

    // Pulls a strength ("50mg") and/or format words (pen/vial/refill/
    // spray/nasal/total) out of the normalized query, used to pick the
    // right variant within each returned product.
    function extractTokens(normQuery) {
      var mgMatch = normQuery.match(/(\d+(?:\.\d+)?)mg/);
      var words = [];
      ['pen', 'vial', 'refill', 'spray', 'nasal', 'total'].forEach(function (w) {
        if (normQuery.indexOf(w) !== -1) words.push(w);
      });
      return { mg: mgMatch ? mgMatch[1] + 'mg' : null, words: words };
    }

    function tokensMatchVariant(variantTitleNorm, tokens) {
      if (tokens.mg && variantTitleNorm.indexOf(tokens.mg) === -1) return false;
      return tokens.words.every(function (w) {
        if (w === 'spray' || w === 'nasal') return variantTitleNorm.indexOf('spray') !== -1 || variantTitleNorm.indexOf('nasal') !== -1;
        return variantTitleNorm.indexOf(w) !== -1;
      });
    }

    // Finds the variant within a product that best matches the typed
    // strength/format; falls back to the product's first/default variant
    // when nothing in the query specifies one.
    function pickVariant(product, tokens) {
      var variants = product.variants || [];
      if (!variants.length) return { variant: null, matched: false };
      if (tokens.mg || tokens.words.length) {
        for (var i = 0; i < variants.length; i++) {
          if (tokensMatchVariant(normalize(variants[i].title), tokens)) {
            return { variant: variants[i], matched: true };
          }
        }
      }
      return { variant: variants[0], matched: false };
    }

    function escapeHtml(s) {
      var d = document.createElement('div');
      d.textContent = s || '';
      return d.innerHTML;
    }

    function showResultsPanel() {
      results.hidden = false;
      // next frame so the display change is committed before the transition starts
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { results.classList.add('hdr-search-results--visible'); });
      });
      input.setAttribute('aria-expanded', 'true');
    }

    function hideResults() {
      results.classList.remove('hdr-search-results--visible');
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
      setTimeout(function () {
        if (!results.classList.contains('hdr-search-results--visible')) {
          results.hidden = true;
          results.innerHTML = '';
        }
      }, 160); // matches CSS transition duration
    }

    function openBar() {
      wrap.classList.add('hdr-search-wrap--open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      lastFocused = document.activeElement;
      input.focus(); // synchronous, inside the click handler's gesture — reliably opens the mobile keyboard
    }
    function closeBar() {
      wrap.classList.remove('hdr-search-wrap--open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      hideResults();
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function showSkeleton() {
      var rows = '';
      for (var i = 0; i < 3; i++) {
        rows += '<div class="hdr-search-skel-row">' +
                  '<span class="hdr-search-skel-thumb"></span>' +
                  '<span class="hdr-search-skel-lines"><span></span><span></span></span>' +
                '</div>';
      }
      results.innerHTML = '<div class="hdr-search-skeleton">' + rows + '</div>';
      showResultsPanel();
    }

    function getFocusableItems() {
      var items = $$('.hdr-search-item', results);
      var viewAll = $('.hdr-search-view-all', results);
      if (viewAll) items = items.concat([viewAll]);
      return items;
    }

    function setActive(idx) {
      var items = getFocusableItems();
      items.forEach(function (el) { el.classList.remove('hdr-search-item--active'); });
      activeIndex = idx;
      if (idx >= 0 && items[idx]) {
        items[idx].classList.add('hdr-search-item--active');
        items[idx].scrollIntoView({ block: 'nearest' });
      }
    }

    function renderResults(products, query) {
      if (!products || !products.length) {
        results.innerHTML = '<p class="hdr-search-empty">' + escapeHtml(noResultsText) + '</p>';
        showResultsPanel();
        return;
      }

      var html = '<ul class="hdr-search-list" role="list">';
      products.forEach(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<span class="hdr-search-thumb-empty"></span>';
        var availClass = p.available ? 'hdr-search-avail--in' : 'hdr-search-avail--out';
        var availText = p.available ? inStockText : soldOutText;
        var variantLine = (p.variantTitle && p.variantTitle !== 'Default Title')
          ? '<span class="hdr-search-variant">' + escapeHtml(p.variantTitle) + '</span>' : '';
        html += '<li role="listitem">' +
                  '<a href="' + p.url + '" class="hdr-search-item">' +
                    '<span class="hdr-search-thumb">' + img + '</span>' +
                    '<span class="hdr-search-info">' +
                      '<span class="hdr-search-title">' + escapeHtml(p.title) + '</span>' +
                      variantLine +
                      '<span class="hdr-search-meta">' +
                        '<span class="hdr-search-price">' + escapeHtml(p.price) + '</span>' +
                        '<span class="hdr-search-avail ' + availClass + '">' + escapeHtml(availText) + '</span>' +
                      '</span>' +
                    '</span>' +
                  '</a>' +
                '</li>';
      });
      html += '</ul>';
      html += '<a href="' + searchUrl + '?q=' + encodeURIComponent(query) + '" class="hdr-search-view-all">' + escapeHtml(viewAllText) + '</a>';

      results.innerHTML = html;
      showResultsPanel();
      activeIndex = -1;
    }

    function runSearch(query) {
      currentQuery = query;
      if (!query || query.trim().length < 2) { hideResults(); return; }

      if (fetchAbort) fetchAbort.abort();
      fetchAbort = ('AbortController' in window) ? new AbortController() : null;

      showSkeleton();

      var resolved = resolveQuery(query);
      var searchText = resolved.search;
      // Extract strength/format tokens from the alias-stripped remainder
      // when an alias matched, otherwise the full query — prevents an
      // alias's own digits (e.g. "31" in "ss31") from bleeding into a
      // strength that follows it (e.g. "25mg").
      var tokens = extractTokens(resolved.remainder);

      var url = '/search/suggest.json?q=' + encodeURIComponent(searchText) +
                '&resources[type]=product&resources[limit]=10' +
                '&resources[options][fields]=title,product_type,variants.title,tag,vendor' +
                '&resources[options][unavailable_products]=show';

      fetch(url, { credentials: 'same-origin', signal: fetchAbort ? fetchAbort.signal : undefined })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (query !== currentQuery) return; // stale response, a newer keystroke already superseded this
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];

          // Bundles only appear on /pages/bundles — never in search suggestions.
          products = products.filter(function (p) {
            var tags = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
            return p.type !== 'Bundle' && tags.indexOf('bundle') === -1;
          });

          // One card per PRODUCT, never per variant — but the card shows
          // whichever variant actually matches the typed strength/format.
          var mapped = products.map(function (p) {
            var picked = pickVariant(p, tokens);
            var v = picked.variant;
            return {
              title: p.title,
              url: v ? (p.url.split('?')[0] + '?variant=' + v.id) : p.url,
              image: p.image,
              price: (v && v.price) ? v.price : p.price,
              available: v ? v.available : p.available,
              variantTitle: v ? v.title : null,
              matched: picked.matched
            };
          });

          // Exact strength/format matches surface first; Shopify's own
          // relevance order is otherwise preserved (stable sort).
          mapped.sort(function (a, b) { return (b.matched ? 1 : 0) - (a.matched ? 1 : 0); });

          renderResults(mapped.slice(0, 8), query);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return; // superseded by a newer request, not a real failure
          hideResults();
        });
    }

    on(input, 'input', function () {
      var q = input.value;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { runSearch(q); }, 150);
    });

    on(input, 'keydown', function (e) {
      var items = getFocusableItems();

      if (e.key === 'ArrowDown') {
        if (!items.length) return;
        e.preventDefault();
        setActive(activeIndex + 1 >= items.length ? 0 : activeIndex + 1);
      } else if (e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        setActive(activeIndex - 1 < 0 ? items.length - 1 : activeIndex - 1);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        var productItems = $$('.hdr-search-item', results);
        if (activeIndex >= 0 && items[activeIndex]) {
          // An explicitly arrow-key-highlighted suggestion always wins,
          // whether that's a product or the "View all results" link.
          window.location = items[activeIndex].getAttribute('href');
        } else if (productItems.length) {
          // Nothing highlighted: open the first (most relevant) suggested
          // product directly — never the general search-results page.
          window.location = productItems[0].getAttribute('href');
        }
        // No matching products: do nothing, no redirect.
      } else if (e.key === 'Escape') {
        hideResults();
        if (wrap.classList.contains('hdr-search-wrap--open')) closeBar();
      }
    });

    if (toggle) {
      on(toggle, 'click', function () {
        if (wrap.classList.contains('hdr-search-wrap--open')) closeBar();
        else openBar();
      });
    }
    if (closeBtn) on(closeBtn, 'click', closeBar);

    on(document, 'click', function (e) {
      if (!wrap.contains(e.target)) hideResults();
    });
  })();

  /* ════════════════════════════════
     FAQ page accordion — smooth expand/collapse via measured scrollHeight.
     Delegated single listener; works for any number of merchant-added
     blocks with no per-item setup needed.
     ════════════════════════════════ */
  (function faqAccordion() {
    var items = $$('.faq-item');
    if (!items.length) return;

    on(document, 'click', function (e) {
      var btn = e.target.closest('.faq-q');
      if (!btn) return;
      var item = btn.closest('.faq-item');
      var panel = item ? $('.faq-a', item) : null;
      if (!panel) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Only one answer open at a time — close every other open item first.
      $$('.faq-q[aria-expanded="true"]').forEach(function (openBtn) {
        if (openBtn === btn) return;
        var openItem = openBtn.closest('.faq-item');
        var openPanel = openItem ? $('.faq-a', openItem) : null;
        openBtn.setAttribute('aria-expanded', 'false');
        if (openPanel) openPanel.style.maxHeight = '0px';
      });

      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    });
  })();

  /* ════════════════════════════════
     Bundles page — Add Bundle to Cart. Reuses the SAME renderDrawer/
     openDrawer functions the main product page uses (defined near the top
     of this file) rather than duplicating cart-drawer logic. Each bundle
     is a single real Shopify variant, so this is a completely standard
     /cart/add call — no custom discount math involved.
     ════════════════════════════════ */
  (function bundleAddToCart() {
    /* Adds the bundle AND its free gift in ONE /cart/add.js request, so
       they always arrive together (Shopify adds an items[] array
       atomically). The gift line is priced normally in the catalogue and
       made free by the real "Free 50 Needle Heads with every Bundle"
       automatic discount — so checkout genuinely charges 0 for it.
       Reuses the same renderDrawer/openDrawer as the product page. */
    var forms = $$('[data-bundle-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var btn = $('.bnd-atc', form);
        var label = btn ? $('.bnd-atc-label', btn) : null;
        if (!btn || btn.disabled) return; // blocks double-tap duplicates

        var bundleId = parseInt(form.dataset.bundleVariant, 10);
        if (!bundleId) return;
        var giftId = parseInt(form.dataset.giftVariant, 10);
        var title = form.dataset.bundleTitle || 'Bundle';

        var items = [{
          id: bundleId,
          quantity: 1,
          properties: { 'Includes': form.dataset.bundleIncludes || '' }
        }];
        if (giftId) {
          items.push({ id: giftId, quantity: 1, properties: { 'Free with': title } });
        }

        var orig = label ? label.textContent : '';
        btn.disabled = true;
        if (label) label.textContent = 'ADDING…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add bundle to cart'); });
            return res.json();
          })
          .then(function () {
            if (label) label.textContent = 'ADDED ✓';
            return renderDrawer();
          })
          .then(function () { setTimeout(openDrawer, 200); })
          .catch(function (err) {
            console.error('Bundle add to cart failed:', err);
            if (label) label.textContent = 'OUT OF STOCK — TRY AGAIN LATER';
          })
          .finally(function () {
            setTimeout(function () {
              btn.disabled = false;
              if (label) label.textContent = orig;
            }, 2000);
          });
      });
    });
  })();



  /* ════════════════════════════════
     WhatsApp order request (cart page).
     Reads the LIVE cart at click time via /cart.js — nothing about products,
     prices or discounts is hard-coded. Opens wa.me pre-filled; the customer
     still presses Send themselves. No order is created and nothing is paid.
     ════════════════════════════════ */
  (function whatsappOrder() {
    var root = $('#wa-order');
    if (!root) return;

    var phone = root.dataset.phone;
    var shipRate = (Number(root.dataset.shipRate) || 0) * 100;
    var shipThreshold = (Number(root.dataset.shipThreshold) || 0) * 100;
    var busy = false;

    var money = function (c) { return 'AED ' + (c / 100).toLocaleString('en-AE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

    /* Stable per-session reference so a customer who reopens WhatsApp quotes
       the same one. Explicitly NOT a Shopify order number. */
    function reference() {
      var key = 'cp_wa_ref';
      try { var ex = sessionStorage.getItem(key); if (ex) return ex; } catch (e) {}
      var d = new Date();
      var stamp = String(d.getFullYear()).slice(2) + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
      var rand = String(Math.floor(Math.random() * 9000) + 1000);
      var ref = 'CP-WA-' + stamp + '-' + rand;
      try { sessionStorage.setItem(key, ref); } catch (e) {}
      return ref;
    }

    /* Saved as cart attributes so the details reach Shopify's order/cart admin.
       Shopify's hosted checkout cannot be pre-filled from theme code, so this
       is the furthest the entered address can reliably travel on the Tabby
       path — the customer still types it once at checkout, but we never lose it. */
    function deliveryAttributes(d, ref) {
      var a = {
        'First Name': d.firstName, 'Last Name': d.lastName, 'Phone': d.phone,
        'Address': d.address, 'City': d.city, 'Emirate': d.emirate, 'Country': d.country,
      };
      if (d.apartment) a['Apartment/Villa'] = d.apartment;
      if (ref) a['WhatsApp Order Reference'] = ref;
      return a;
    }

    /* Tabby / Shopify checkout: persist whatever has been typed before leaving,
       so it is attached to the cart rather than lost. */
    on(document, 'click', function (ev) {
      var link = ev.target.closest('.cart-tabby-btn');
      if (!link) return;
      var d = details();
      if (!d.firstName && !d.phone && !d.address) return; // nothing entered; go straight through
      ev.preventDefault();
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: deliveryAttributes(d, null) }),
      }).catch(function () {}).finally(function () { window.location.href = link.getAttribute('href'); });
    });

    /* A <select> always has a value, so the floating label needs a class hook. */
    function syncSelectLabels() {
      $$('.wa-f select').forEach(function (sel) {
        var lbl = sel.parentNode.querySelector('label');
        if (lbl) lbl.classList.toggle('is-filled', !!sel.value);
      });
    }
    $$('.wa-f select').forEach(function (sel) { on(sel, 'change', syncSelectLabels); });
    syncSelectLabels();

    /* Keep the phone input to digits only; the +971 prefix is shown separately. */
    var phoneInput = $('#wa-phone');
    if (phoneInput) {
      on(phoneInput, 'input', function () {
        var v = phoneInput.value.replace(/\D/g, '').replace(/^971/, '').replace(/^0/, '');
        phoneInput.value = v.slice(0, 9);
      });
    }

    function details() {
      var get = function (id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; };
      var first = get('wa-first-name'), last = get('wa-last-name');
      var localPhone = get('wa-phone').replace(/\D/g, '').replace(/^971/, '').replace(/^0/, '');
      return {
        firstName: first, lastName: last,
        name: (first + ' ' + last).trim(),
        phone: localPhone ? '+971' + localPhone : '',
        address: get('wa-address'), apartment: get('wa-apartment'),
        city: get('wa-city'), emirate: get('wa-emirate'),
        country: 'United Arab Emirates',
      };
    }

    function focusField(el) {
      if (!el) return;
      el.classList.add('wa-input--error');
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { el.focus({ preventScroll: true }); }, 350);
    }

    function validate(d) {
      var required = [
        ['wa-first-name', d.firstName], ['wa-last-name', d.lastName],
        ['wa-address', d.address], ['wa-city', d.city],
        ['wa-emirate', d.emirate], ['wa-phone', d.phone],
      ];
      var firstBad = null;
      required.forEach(function (pair) {
        var el = document.getElementById(pair[0]);
        var bad = !pair[1];
        if (el) el.classList.toggle('wa-input--error', bad);
        if (bad && !firstBad) firstBad = el;
      });
      if (firstBad) { focusField(firstBad); return 'Please complete all required delivery details.'; }
      if (d.phone.replace(/\D/g, '').length !== 12) {   // +971 + 9 digits
        focusField(document.getElementById('wa-phone'));
        return 'Please enter a valid UAE mobile number (9 digits after +971).';
      }
      return null;
    }

    function buildMessage(cart, d, ref) {
      var L = [];
      L.push('Hello CorePeptides 🧬', '', 'I would like to place an order:', '');

      L.push('CUSTOMER DETAILS');
      L.push('Name: ' + d.name);
      L.push('Phone: ' + d.phone);
      L.push('Address: ' + d.address);
      if (d.apartment) L.push('Apartment/Villa: ' + d.apartment);
      L.push('City: ' + d.city);
      L.push('Emirate: ' + d.emirate);
      L.push('Country: ' + d.country);
      L.push('', 'ORDER', '');

      cart.items.forEach(function (i) {
        L.push(i.product_title);
        var variant = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : '';
        L.push((variant ? variant + ' × ' : '× ') + i.quantity + '  —  ' + money(i.final_line_price));
        if (i.final_price !== i.original_price) L.push('  (discounted from ' + money(i.original_line_price) + ')');
        // Line-item properties carry bundle contents and the free-gift marker.
        if (i.properties) {
          Object.keys(i.properties).forEach(function (k) {
            if (k.charAt(0) === '_' || !i.properties[k]) return;
            L.push('  ' + k + ': ' + i.properties[k]);
          });
        }
        L.push('');
      });

      /* Discount lines come straight from Shopify's cart payload — only a code
         Shopify actually accepted can appear here, so the WhatsApp total always
         matches the total the customer saw in the cart. */
      var codes = ((cart.discount_codes || []).filter(function (d) { return d.applicable !== false && d.code; }).map(function (d) { return d.code; }))
        .concat((cart.cart_level_discount_applications || []).map(function (d) { return d.title; }).filter(Boolean));
      codes = codes.filter(function (c, i) { return c && codes.indexOf(c) === i; });
      var saved = cart.total_discount || 0;

      if (saved > 0) {
        if (codes.length) L.push('Discount Code: ' + codes.join(', '));
        L.push('Original Subtotal: ' + money(cart.total_price + saved));
        L.push('Discount: − ' + money(saved));
        L.push('Subtotal: ' + money(cart.total_price));
      } else {
        L.push('Subtotal: ' + money(cart.total_price));
      }

      // Delivery is only stated because the store's real Shopify rule is a
      // simple flat rate + free-over threshold. If either is unset we say
      // "to be confirmed" rather than show a figure we can't stand behind.
      if (shipRate > 0 || shipThreshold > 0) {
        var ship = (shipThreshold && cart.total_price >= shipThreshold) ? 0 : shipRate;
        L.push('Delivery: ' + (ship === 0 ? 'FREE' : money(ship)));
        L.push('Total: ' + money(cart.total_price + ship));
      } else {
        L.push('Delivery: To be confirmed', 'Final Total: To be confirmed');
      }

      L.push('', 'WhatsApp Order Reference: ' + ref, '');
      L.push('Please confirm availability and send me the available payment instructions.', '', 'Thank you.');
      return L.join('\n');
    }

    /* The CTA sits inside the cart summary, which is re-rendered on every
       quantity/discount change, so a direct listener would be lost. Delegating
       from document keeps one handler alive for the life of the page. */
    on(document, 'click', function (ev) {
      var btn = ev.target.closest('#wa-btn');
      if (!btn) return;
      var label = document.getElementById('wa-btn-label');
      var errEl = document.getElementById('wa-error');
      var refEl = document.getElementById('wa-ref-display');
      if (busy) return;                               // blocks double-clicks / duplicate windows
      if (errEl) errEl.hidden = true;

      var d = details();
      var problem = validate(d);
      if (problem) { if (errEl) { errEl.textContent = problem; errEl.hidden = false; } return; }

      busy = true;
      btn.disabled = true;
      var original = label ? label.textContent : '';
      if (label) label.textContent = 'Preparing your order…';

      // Opened synchronously so mobile Safari doesn't treat it as a popup.
      var win = window.open('', '_blank');

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items || !cart.items.length) throw new Error('Your cart is empty.');
          var ref = reference();

          // Store details + reference on the cart. Non-destructive: attributes
          // only, so prices, discounts, bundles and existing cart attributes
          // are untouched, and the info survives if they later use checkout.
          fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: deliveryAttributes(d, ref) }),
          }).catch(function () {});

          var url = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(buildMessage(cart, d, ref));
          if (win) win.location = url; else window.location.href = url;

          if (refEl) { refEl.textContent = 'WhatsApp Order Reference: ' + ref; refEl.hidden = false; }
        })
        .catch(function (e) {
          if (win) win.close();
          if (errEl) {
            errEl.textContent = e.message === 'Your cart is empty.' ? e.message : 'Could not prepare your order. Please try again.';
            errEl.hidden = false;
            errEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        })
        .finally(function () {
          busy = false; btn.disabled = false; if (label) label.textContent = original;
        });
    });
  })();


  /* ════════════════════════════════
     Vials collection page — add the exact vial variant to the cart.
     Delegated so it survives any re-render, and reuses the same
     renderDrawer/openDrawer as the rest of the theme.
     ════════════════════════════════ */
  (function vialsAddToCart() {
    if (!$('.vials-pg')) return;
    var busy = false;

    on(document, 'submit', function (ev) {
      var form = ev.target.closest('[data-vial-form]');
      if (!form) return;
      ev.preventDefault();
      if (busy) return;                                  // blocks double-taps

      var id = parseInt(form.dataset.variant, 10);
      if (!id) return;
      var btn = $('.vial-atc', form);
      var label = btn ? $('.vial-atc-label', btn) : null;
      if (!btn || btn.disabled) return;

      var original = label ? label.textContent : '';
      busy = true;
      btn.disabled = true;
      if (label) label.textContent = 'ADDING…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); });
          return res.json();
        })
        .then(function () {
          if (label) label.textContent = 'ADDED ✓';
          return renderDrawer();
        })
        .then(function () { setTimeout(openDrawer, 200); })
        .catch(function (e) {
          console.error('Vial add to cart failed:', e);
          if (label) label.textContent = 'UNAVAILABLE';
        })
        .finally(function () {
          setTimeout(function () {
            busy = false; btn.disabled = false;
            if (label) label.textContent = original;
          }, 1800);
        });
    });
  })();

})();

/* ════════════════════════════════════════════════════════════
   PRODUCTS DROPDOWN — desktop popup + mobile accordion
   No library, no jQuery. Navigation is never intercepted:
   the menu items are plain <a> elements, so a click on one
   follows the link immediately with no JS delay.
   ════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ---------- Desktop ---------- */
  var dWrap = document.querySelector('[data-hdr-sub]');
  var dBtn = document.getElementById('products-toggle');
  var dMenu = document.getElementById('products-submenu');

  if (dWrap && dBtn && dMenu) {
    var dLinks = function () {
      return Array.prototype.slice.call(dMenu.querySelectorAll('.hdr-sub-link'));
    };

    var setOpen = function (open, focusTarget) {
      dWrap.classList.toggle('is-open', open);
      dBtn.setAttribute('aria-expanded', String(open));
      if (open && focusTarget) {
        /* The panel is visibility:hidden while closed, and a hidden element
           cannot take focus. Reading a layout property forces the browser to
           apply the class we just set, so the panel is already visible by the
           time focus() runs — doing this on a later frame instead would race
           with further key presses. */
        void dMenu.offsetHeight;
        var l = dLinks();
        if (l.length) (focusTarget === 'last' ? l[l.length - 1] : l[0]).focus();
      }
    };

    var isOpen = function () { return dWrap.classList.contains('is-open'); };

    dBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      setOpen(!isOpen(), null);
    });

    dBtn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(true, 'first'); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setOpen(true, 'last'); }
    });

    dMenu.addEventListener('keydown', function (e) {
      var l = dLinks();
      var i = l.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); if (l.length) l[(i + 1) % l.length].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (l.length) l[(i - 1 + l.length) % l.length].focus(); }
      else if (e.key === 'Home') { e.preventDefault(); if (l.length) l[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); if (l.length) l[l.length - 1].focus(); }
      else if (e.key === 'Tab') { setOpen(false, null); } /* tabbing out closes it */
    });

    /* Escape closes and returns focus to the trigger */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        setOpen(false, false);
        dBtn.focus();
      }
    });

    /* Click anywhere outside closes it */
    document.addEventListener('click', function (e) {
      if (isOpen() && !dWrap.contains(e.target)) setOpen(false, false);
    });
  }

  /* ---------- Mobile accordion ---------- */
  var mWrap = document.querySelector('[data-mnav-sub]');
  var mBtnSub = document.getElementById('m-products-toggle');
  var mDrawer = document.getElementById('mobile-nav');

  if (mWrap && mBtnSub) {
    mBtnSub.addEventListener('click', function (e) {
      e.preventDefault();
      var open = mWrap.classList.toggle('is-open');
      mBtnSub.setAttribute('aria-expanded', String(open));
      /* The drawer has a fixed max-height; widen it while the
         submenu is open so the links below are not clipped. */
      if (mDrawer) mDrawer.classList.toggle('mnav-expanded', open);
    });
  }
})();
